<qaroni-account-profile [account]="data" (closeProfile)="close()" />
